
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-free-vs-premium-comparison",
      function () {
        return require("private-next-pages/article/teamsreminder-free-vs-premium-comparison.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-free-vs-premium-comparison"])
      });
    }
  